import { IApp03TaskUser } from '../types';
import { EntityService } from './EntityService';

export class App03TaskUserService extends EntityService<IApp03TaskUser> {
    constructor() {
        super(`/App03TaskUsers`);
    }
}